import * as React from "react";
import styled from "styled-components";

type Props = {
  imgUrl?: string | null;
  label: string;
};

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const StyledSignatureImage = styled.div`
  max-width: 300px;

  img {
    max-width: 100%;
    max-height: 200px;
  }
`;

export const CompanyDetailImage: React.FunctionComponent<Props> = props => {
  return (
    <>
      {props.imgUrl && (
        <>
          <StyledWrapper className={"row"}>
            <div className={"row-title"}>{props.label}</div>
            <div>
              <StyledSignatureImage>
                <img src={props.imgUrl} alt={props.label} />
              </StyledSignatureImage>
            </div>
          </StyledWrapper>
          <hr />
        </>
      )}
    </>
  );
};
